<template>
  <div class="">
    <label for="fileUpload">{{ label }}</label>
    <input type="file" multiple @change="onFileChange($event)" id="fileUpload" class="form-control"/>
  </div>
</template>
<script>
  let toBase64;
  export default {
    name: 'TextareaField',
    props: {
      value: String,
      uniqueId: Number,
      label: String,
    },
    computed: {
      inputValue: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      }
    },
    methods: {
      onFileChange(e) {
        console.log("hi");
        this.inputValue = e.target.files[0];
      },
    }
  }
</script>
<style>
</style>
